import * as types from './actionTypes';
import initialState from './initialState';
import { LOGOUT_USER_SUCCESS } from '../session/actionTypes';

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.GET_ALL_PROJECTS_REQUEST:
      return {
        ...state,
        all: {
          ...state.all,
          isLoading: true,
        },
      };
    case types.GET_ALL_PROJECTS_SUCCESS:
      return {
        ...state,
        all: {
          ...state.all,
          isLoading: false,
          data: action.payload.projects,
        },
      };
    case types.GET_ALL_PROJECTS_ERROR:
      return {
        ...state,
        all: {
          ...state.all,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.CANCEL_GET_ALL_PROJECTS:
      return {
        ...state,
        all: {
          ...state.all,
          isLoading: false,
        },
      };
    case types.GET_PROJECTS_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: true,
        },
      };
    case types.GET_PROJECTS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          data: {
            ...state.list.data,
            items: action.payload.projects,
            count: action.payload.count,
          },
        },
      };
    case types.GET_PROJECTS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.ADD_PROJECT_REQUEST:
      return {
        ...state,
        add: {
          ...state.add,
          isLoading: true,
        },
      };
    case types.ADD_PROJECT_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          isLoading: false,
        },
      };
    case types.ADD_PROJECT_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.IMPORT_PROJECT_REQUEST:
      return {
        ...state,
        import: {
          ...state.import,
          isLoading: true,
        },
      };
    case types.IMPORT_PROJECT_SUCCESS:
      return {
        ...state,
        import: {
          ...state.import,
          isLoading: false,
        },
      };
    case types.IMPORT_PROJECT_ERROR:
      return {
        ...state,
        import: {
          ...state.import,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.CLONE_PROJECT_REQUEST:
      return {
        ...state,
        clone: {
          ...state.clone,
          isLoading: true,
        },
      };
    case types.CLONE_PROJECT_SUCCESS:
      return {
        ...state,
        clone: {
          ...state.clone,
          isLoading: false,
        },
      };
    case types.CLONE_PROJECT_ERROR:
      return {
        ...state,
        clone: {
          ...state.clone,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.UPDATE_PROJECTS_PAGINATION_PARAMS:
      return {
        ...state,
        list: {
          ...state.list,
          paginationOptions: action.payload.paginationOptions,
        },
      };
    case types.RESET_PROJECTS_PAGINATION_PARAMS:
    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          paginationOptions: {
            page: 1,
            size: 9,
            name__icontains: '',
            ordering: '-updated_at',
          },
        },
      };
    case types.TOGGLE_PROJECTS_GRID:
      return {
        ...state,
        list: {
          ...state.list,
          isGrid: action.payload.isGrid,
        },
      };
    default:
      return state;
  }
};
